(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not([data-mt-observed])');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) {
      el.setAttribute('data-mt-observed', '1');
      obs.observe(el);
    });
  }

  function initComparadores(root) {
    var comps = (root || document).querySelectorAll('.mt-comparador[data-mt-init="pendiente"]');
    comps.forEach(function (comp) {
      comp.dataset.mtInit = '1';
      var antes = comp.querySelector('.mt-comparador-antes');
      var asa = comp.querySelector('.mt-comparador-asa');
      var range = comp.querySelector('.mt-comparador-range');
      if (!antes || !asa || !range) return;
      function set(v) {
        var pct = Math.min(100, Math.max(0, v));
        antes.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        asa.style.left = pct + '%';
      }
      range.addEventListener('input', function () { set(Number(range.value)); });
      set(Number(range.value || 50));
    });
  }

  function initCompraSwatches(root) {
    var wraps = (root || document).querySelectorAll('.mt-compra-buy[data-mt-init="pendiente"]');
    wraps.forEach(function (buyWrap) {
      buyWrap.dataset.mtInit = '1';
      var form = buyWrap.querySelector('.mt-compra-form');
      var infoWrap = buyWrap.closest('.mt-compra-info') || buyWrap.parentElement;
      if (!form || !infoWrap) return;
      var datosEl = infoWrap.querySelector('.mt-compra-datos');
      var datos = [];
      try { datos = JSON.parse((datosEl && datosEl.textContent) || '[]'); } catch (e) { datos = []; }
      // price test: group B sees the lower price (the matching discount code is applied silently)
      var descuentoTest = window.__mtDescuento || 0;
      if (descuentoTest) {
        datos.forEach(function (d) {
          var antes = d.cents;
          d.cents = antes - descuentoTest;
          d.price = dinero(d.cents, d.price);
          if (window.__mtPromo) { d.compareAtPrice = dinero(antes, d.price); d.discount = Math.round(descuentoTest * 100 / antes); }
        });
      }
      var input = form.querySelector('.mt-compra-variant-input');
      var precioEls = document.querySelectorAll('.mt-compra-precio-din');
      var tachadoEl = infoWrap.querySelector('.mt-compra-precio-tachado-din');
      var badgeEl = infoWrap.parentElement && infoWrap.parentElement.querySelector('.mt-compra-badge');
      var imgEl = infoWrap.parentElement && infoWrap.parentElement.querySelector('.mt-compra-img');
      var stickyImgEl = document.querySelector('[data-mt-sticky-comprar-img]');
      var colorActualEl = infoWrap.querySelector('.mt-compra-color-actual');
      var presActualEl = infoWrap.querySelector('.mt-compra-presentacion-actual');
      var swatches = infoWrap.querySelectorAll('.mt-swatch');
      var pills = infoWrap.querySelectorAll('.mt-pill');

      var colorActual = swatches.length ? swatches[0].getAttribute('data-mt-color') : null;
      swatches.forEach(function (s) { if (s.classList.contains('mt-swatch--activo')) colorActual = s.getAttribute('data-mt-color'); });
      var presActual = pills.length ? pills[0].getAttribute('data-mt-presentacion') : null;
      pills.forEach(function (p) { if (p.classList.contains('mt-pill--activo')) presActual = p.getAttribute('data-mt-presentacion'); });

      function nombreDe(color) {
        for (var i = 0; i < swatches.length; i++) {
          if (swatches[i].getAttribute('data-mt-color') === color) return swatches[i].getAttribute('data-mt-nombre') || color;
        }
        return color;
      }
      if (colorActualEl && colorActual) colorActualEl.textContent = nombreDe(colorActual);

      function aplicar() {
        var v = datos.filter(function (d) {
          var colorOk = !colorActual || d.color === colorActual;
          var presOk = !presActual || d.presentacion === presActual;
          return colorOk && presOk;
        })[0];
        if (!v) return;
        if (input) input.value = v.id;
        precioEls.forEach(function (el) { el.textContent = v.price; });
        document.querySelectorAll('.mt-salida-precio').forEach(function (el) { el.textContent = v.price; });
        if (tachadoEl) { if (v.compareAtPrice) { tachadoEl.textContent = v.compareAtPrice; tachadoEl.style.display = ''; } else { tachadoEl.style.display = 'none'; } }
        if (badgeEl) { if (v.discount) { badgeEl.textContent = '-' + v.discount + '%'; badgeEl.style.display = ''; } else { badgeEl.style.display = 'none'; } }
        // a lifestyle photo set in the section stays on screen until the visitor picks a variant
        var conservarInicial = imgEl && imgEl.getAttribute('data-mt-inicial') === '1' && !window.__mtElegido;
        if (!conservarInicial && imgEl && v.image && imgEl.src.indexOf(v.image) === -1) { imgEl.style.opacity = '0'; setTimeout(function () { imgEl.src = v.image; imgEl.style.opacity = '1'; }, 150); }
        if (stickyImgEl && v.image && stickyImgEl.src.indexOf(v.image) === -1) { stickyImgEl.src = v.image; }
        var kitEl = infoWrap.parentElement && infoWrap.parentElement.querySelector('.mt-compra-kit-lista');
        if (kitEl) kitEl.hidden = !v.kit;
        if (colorActualEl) colorActualEl.textContent = nombreDe(v.color);
        if (presActualEl) presActualEl.textContent = v.presentacion;
        actualizarPack(v);
        if (packActual > 1) pintarFilas();
        document.dispatchEvent(new CustomEvent('mt:color', { detail: { color: v.color } }));
      }

      var qtyInput = form.querySelector('input[name="quantity"]');
      var packBtns = buyWrap.querySelectorAll('.mt-pack-opcion');
      var eleccionEl = buyWrap.querySelector('.mt-pack-eleccion');
      var filasEl = buyWrap.querySelector('.mt-pack-filas');
      var botonCompra = form.querySelector('button[type="submit"]');
      var textoBoton = botonCompra ? botonCompra.textContent.trim() : '';
      var packActual = 1;
      var elegidos = [];            // colors picked for brushes 2 and 3 (brush 1 always follows the main selection)
      function dinero(centavos, muestra) {
        var simbolo = String(muestra || '$').replace(/[0-9].*$/, '');
        return simbolo + (centavos / 100).toFixed(2);
      }
      function precioPack(n) { return parseInt(buyWrap.getAttribute('data-mt-pack' + n), 10) || 0; }
      function actualizarPack(v) {
        if (!packBtns.length || !v) return;
        var uno = buyWrap.querySelector('[data-mt-pack-precio="1"]');
        var unoAntes = buyWrap.querySelector('[data-mt-pack-antes="1"]');
        if (uno) uno.textContent = v.price;
        if (unoAntes) unoAntes.textContent = (window.__mtPromo && v.compareAtPrice) ? v.compareAtPrice : '';
      }
      function opciones() {
        var lista = [];
        swatches.forEach(function (s) {
          var color = s.getAttribute('data-mt-color');
          var d = datos.filter(function (x) { return x.color === color; })[0];
          var im = s.querySelector('img');
          if (d) lista.push({ color: color, id: d.id, nombre: s.getAttribute('data-mt-nombre') || color, img: im ? im.getAttribute('src') : '', swatch: s });
        });
        return lista;
      }
      function pintarFilas() {
        if (!filasEl) return;
        var lista = opciones();
        filasEl.innerHTML = '';
        for (var i = 0; i < packActual; i++) {
          (function (i) {
            var fila = document.createElement('div'); fila.className = 'mt-pack-fila';
            var et = document.createElement('span'); et.className = 'mt-pack-fila-etiqueta'; et.textContent = 'Brush ' + (i + 1);
            var chips = document.createElement('div'); chips.className = 'mt-pack-chips';
            var actualFila = i === 0 ? colorActual : (elegidos[i] || colorActual);
            lista.forEach(function (o) {
              var b = document.createElement('button'); b.type = 'button'; b.className = 'mt-pack-chip' + (o.color === actualFila ? ' mt-pack-chip--activo' : '');
              b.setAttribute('aria-pressed', o.color === actualFila ? 'true' : 'false'); b.title = o.nombre;
              if (o.img) { var im = document.createElement('img'); im.src = o.img; im.alt = ''; b.appendChild(im); }
              var tx = document.createElement('span'); tx.textContent = o.nombre.replace(' · ', ' '); b.appendChild(tx);
              b.addEventListener('click', function () {
                if (i === 0) { o.swatch.click(); } else { elegidos[i] = o.color; pintarFilas(); }
              });
              chips.appendChild(b);
            });
            fila.appendChild(et); fila.appendChild(chips); filasEl.appendChild(fila);
          })(i);
        }
      }
      function actualizarBoton() {
        if (!botonCompra) return;
        botonCompra.textContent = packActual > 1 ? textoBoton + ' · ' + dinero(precioPack(packActual)) : textoBoton;
      }
      packBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          packActual = parseInt(b.getAttribute('data-mt-pack'), 10) || 1;
          if (qtyInput) qtyInput.value = packActual;
          packBtns.forEach(function (o) { o.classList.remove('mt-pack-opcion--activa'); o.setAttribute('aria-checked', 'false'); });
          b.classList.add('mt-pack-opcion--activa');
          b.setAttribute('aria-checked', 'true');
          if (eleccionEl) eleccionEl.hidden = packActual === 1;
          var expressEl = buyWrap.querySelector('[data-mt-express]');
          if (expressEl) expressEl.hidden = packActual > 1; // wallet buttons only for a single brush
          for (var i = 1; i < packActual; i++) { if (!elegidos[i]) elegidos[i] = colorActual; }
          if (packActual > 1) pintarFilas();
          actualizarBoton();
        });
      });
      // several different brushes: add them as separate cart lines (the bundle discount counts them together)
      form.addEventListener('submit', function (e) {
        if (packActual === 1) return;
        e.preventDefault();
        var cuenta = {};
        for (var i = 0; i < packActual; i++) {
          var color = i === 0 ? colorActual : (elegidos[i] || colorActual);
          var d = datos.filter(function (x) { return x.color === color; })[0];
          if (d) cuenta[d.id] = (cuenta[d.id] || 0) + 1;
        }
        var items = Object.keys(cuenta).map(function (id) { return { id: Number(id), quantity: cuenta[id] }; });
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); if (window.mtDrawer) { window.mtDrawer.open(); } else { window.location.href = '/cart'; } })
          .catch(function () { form.submit(); });
      });

      var minis = infoWrap.parentElement ? infoWrap.parentElement.querySelectorAll('.mt-mini') : [];
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          var src = m.getAttribute('data-mt-mini');
          minis.forEach(function (o) { o.classList.remove('mt-mini--activa'); });
          m.classList.add('mt-mini--activa');
          if (imgEl && src) { imgEl.style.opacity = '0'; setTimeout(function () { imgEl.src = src; imgEl.style.opacity = '1'; }, 150); }
        });
      });

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          colorActual = sw.getAttribute('data-mt-color');
          swatches.forEach(function (s) { s.classList.remove('mt-swatch--activo'); s.setAttribute('aria-pressed', 'false'); });
          sw.classList.add('mt-swatch--activo');
          sw.setAttribute('aria-pressed', 'true');
          window.__mtElegido = true;
          aplicar();
        });
      });
      pills.forEach(function (p) {
        p.addEventListener('click', function () {
          presActual = p.getAttribute('data-mt-presentacion');
          pills.forEach(function (o) { o.classList.remove('mt-pill--activo'); o.setAttribute('aria-pressed', 'false'); });
          p.classList.add('mt-pill--activo');
          p.setAttribute('aria-pressed', 'true');
          window.__mtElegido = true;
          aplicar();
        });
      });

      actualizarPack(datos.filter(function (d) {
        return (!colorActual || d.color === colorActual) && (!presActual || d.presentacion === presActual);
      })[0]);
      if (descuentoTest) aplicar(); // show the test price right away (including the sticky bar)

      // discount code box: the visitor types the code, the lower price shows at once and the code is saved in the cart
      var cfgCodigo = window.__mtCodigo;
      var cajaCodigo = infoWrap.querySelector('[data-mt-codigo]');
      if (cfgCodigo && cajaCodigo && cfgCodigo.previa) {
        // outside the offer window: only a preview link shows the box, and the real cart is left alone
        if (/[?&]vista=codigo/.test(window.location.search)) { cajaCodigo.hidden = false; } else { cajaCodigo.parentNode.removeChild(cajaCodigo); cajaCodigo = null; }
      }
      if (cfgCodigo && cajaCodigo) {
        var campoCodigo = cajaCodigo.querySelector('[data-mt-codigo-campo]');
        var botonCodigo = cajaCodigo.querySelector('[data-mt-codigo-boton]');
        var mensajeCodigo = cajaCodigo.querySelector('[data-mt-codigo-mensaje]');
        var okCodigo = cajaCodigo.querySelector('[data-mt-codigo-ok]');
        var formCodigo = cajaCodigo.querySelector('[data-mt-codigo-form]');
        var codigoPuesto = false;
        var guardarCodigo = function () {
          if (cfgCodigo.previa) return;
          try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ discount: cfgCodigo.code }) }); } catch (e) {}
          try { fetch('/discount/' + encodeURIComponent(cfgCodigo.code), { credentials: 'same-origin' }); } catch (e) {}
        };
        var ponerCodigo = function () {
          if (codigoPuesto) return;
          codigoPuesto = true;
          datos.forEach(function (d) {
            var antes = d.cents;
            d.compareAtPrice = dinero(antes, d.price);
            d.cents = Math.max(0, antes - cfgCodigo.off);
            d.price = dinero(d.cents, d.price);
            d.discount = antes ? Math.round(cfgCodigo.off * 100 / antes) : 0;
          });
          window.__mtPromo = true;
          var base = Math.min.apply(null, datos.map(function (d) { return d.cents; }));
          [2, 3].forEach(function (n) {
            var orig = parseInt(buyWrap.getAttribute('data-mt-pack' + n), 10) || 0;
            var efectivo = Math.min(orig, base * n);
            buyWrap.setAttribute('data-mt-pack' + n, efectivo);
            var el = buyWrap.querySelector('[data-mt-pack-precio="' + n + '"]');
            if (el) el.textContent = dinero(efectivo, datos[0].price);
          });
          aplicar();
          actualizarBoton();
          if (formCodigo) formCodigo.hidden = true;
          if (okCodigo) okCodigo.hidden = false;
          cajaCodigo.classList.add('mt-codigo--ok');
        };
        var probarCodigo = function () {
          var escrito = (campoCodigo.value || '').replace(/\s+/g, '').toUpperCase();
          if (!escrito) return;
          if (escrito === String(cfgCodigo.code).toUpperCase()) {
            mensajeCodigo.textContent = '';
            ponerCodigo();
            guardarCodigo();
            if (!cfgCodigo.previa) { try { localStorage.setItem('mt_codigo', cfgCodigo.code); } catch (e) {} }
          } else {
            mensajeCodigo.textContent = 'That code is not valid. Please check it and try again.';
          }
        };
        botonCodigo.addEventListener('click', probarCodigo);
        campoCodigo.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); probarCodigo(); } });
        // a visitor who already used the code (or opened a link with ?code=) sees the price straight away
        var guardado = null;
        try { guardado = localStorage.getItem('mt_codigo'); } catch (e) {}
        var enLink = /[?&]code=([^&]+)/.exec(window.location.search);
        if ((guardado && guardado === cfgCodigo.code) || (enLink && decodeURIComponent(enLink[1]).toUpperCase() === String(cfgCodigo.code).toUpperCase())) {
          ponerCodigo();
          guardarCodigo();
        }
      }
    });
  }

  function initTimer(root) {
    var timers = (root || document).querySelectorAll('[data-mt-timer]:not([data-mt-observed])');
    timers.forEach(function (timer) {
      timer.setAttribute('data-mt-observed', '1');
      var hEl = timer.querySelector('[data-mt-timer-h]');
      var mEl = timer.querySelector('[data-mt-timer-m]');
      var sEl = timer.querySelector('[data-mt-timer-s]');
      if (!hEl || !mEl || !sEl) return;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var ahora = new Date();
        var medianoche = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate() + 1, 0, 0, 0);
        var restante = Math.max(0, medianoche - ahora);
        var h = Math.floor(restante / 3600000);
        var m = Math.floor((restante % 3600000) / 60000);
        var s = Math.floor((restante % 60000) / 1000);
        hEl.textContent = pad(h);
        mEl.textContent = pad(m);
        sEl.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function initSalida(root) {
    var overlay = (root || document).querySelector('[data-mt-salida-overlay]:not([data-mt-observed])');
    if (!overlay) return;
    overlay.setAttribute('data-mt-observed', '1');

    var YA_MOSTRADO_KEY = 'mt_salida_mostrado';
    function yaMostrado() {
      try { return sessionStorage.getItem(YA_MOSTRADO_KEY) === '1'; } catch (e) { return false; }
    }
    function marcarMostrado() {
      try { sessionStorage.setItem(YA_MOSTRADO_KEY, '1'); } catch (e) {}
    }
    function mostrar() {
      if (yaMostrado()) return;
      marcarMostrado();
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('mt-salida-visible'); });
    }
    function ocultar() {
      overlay.classList.remove('mt-salida-visible');
      setTimeout(function () { overlay.hidden = true; }, 250);
    }

    overlay.querySelectorAll('[data-mt-salida-cerrar]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (btn.tagName === 'A') { e.preventDefault(); ocultar(); setTimeout(function () { window.location.hash = btn.getAttribute('href'); }, 260); }
        else { ocultar(); }
      });
    });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) ocultar(); });

    if (yaMostrado()) return;

    // Desktop: mouse leaves toward the browser chrome (closing tab / address bar)
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) mostrar();
    });

    // Mobile: scrolled down a good amount, then scrolls back up near the top (giving up)
    var maxScroll = 0;
    var inicio = Date.now();
    window.addEventListener('scroll', function () {
      var y = window.scrollY || window.pageYOffset;
      if (y > maxScroll) maxScroll = y;
      var tiempoEnPagina = Date.now() - inicio;
      if (maxScroll > window.innerHeight * 1.3 && y < 120 && tiempoEnPagina > 12000) mostrar();
    }, { passive: true });

    // Mobile fallback: still on the page after a while, never showed it
    setTimeout(function () { mostrar(); }, 45000);
  }

  function initStickyComprar(root) {
    var bar = (root || document).querySelector('[data-mt-sticky-comprar]:not([data-mt-observed])');
    var tarjeta = document.querySelector('.mt-compra-tarjeta');
    if (!bar || !tarjeta) return;
    bar.setAttribute('data-mt-observed', '1');

    var boton = bar.querySelector('[data-mt-sticky-comprar-boton]');
    if (boton) {
      boton.addEventListener('click', function () {
        var form = document.querySelector('.mt-compra-form');
        if (form) { if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); } }
      });
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('mt-sticky-comprar-visible');
        } else if (entry.boundingClientRect.top < 0 || window.scrollY > 120) {
          bar.hidden = false;
          requestAnimationFrame(function () { bar.classList.add('mt-sticky-comprar-visible'); });
        }
      });
    }, { threshold: 0 });
    // Watch the real buy button (not the whole card) so the bar appears as soon as it scrolls out of view
    var objetivo = document.querySelector('.mt-compra-form .mt-btn') || tarjeta;
    obs.observe(objetivo);
    window.addEventListener('scroll', function () {
      if (window.scrollY > 120 && !bar.classList.contains('mt-sticky-comprar-visible')) {
        var r = objetivo.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) {
          bar.hidden = false;
          bar.classList.add('mt-sticky-comprar-visible');
        }
      }
    }, { passive: true });
  }

  // Estimated delivery dates, counted in calendar days from today (visitor's own calendar)
  function initEntrega(root) {
    (root || document).querySelectorAll('[data-mt-entrega]:not([data-mt-observed])').forEach(function (el) {
      el.setAttribute('data-mt-observed', '1');
      var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
      var fechasEl = el.querySelector('.mt-entrega-fechas');
      if (!fechasEl || !min || !max) return;
      if (el.getAttribute('data-formato') === 'dias') return; // keep the "Arrives in X-Y days" text from the page
      function sumar(n) {
        var d = new Date();
        d.setDate(d.getDate() + n);
        return d;
      }
      function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
      try { fechasEl.textContent = 'Estimated delivery: ' + fmt(sumar(min)) + ' – ' + fmt(sumar(max)); } catch (e) {}
    });
  }

  function initTodo(e) {
    var root = (e && e.target) || document;
    initReveal(root);
    initComparadores(root);
    initCompraSwatches(root);
    initEntrega(root);
    initTimer(root);
    initSalida(root);
    initStickyComprar(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  document.addEventListener('shopify:section:load', initTodo);
})();
